// @flow
import type { RenderOptionFunc } from '../core/Dropdown'

/**
 * Provides a way to filter a list of options by a given query string
 * @param  {string} query
 * @param  {Array<any>} options
 * @param  {RenderOptionFunc} renderer
 * @return {Array<any>}
 */
const filterOptions = (
  query: string,
  options: Array<any>,
  renderer: RenderOptionFunc
): Array<any> => {
  const normQuery = query.toLowerCase().trim()
  const topResults = []
  const otherResults = []

  for (let i = 0; i < options.length; i++) {
    const option = options[i]
    const renderedOption = renderer(options[i], {})
    if (typeof renderedOption !== 'string') {
      // eslint-disable-next-line no-console
      console.warn('Default options filter can work only with strings!')
      return options
    }

    const normOption = renderedOption.toLowerCase().trim()
    if (normOption.startsWith(normQuery)) {
      topResults.push(option)
    } else if (normOption.indexOf(normQuery) >= 0) {
      otherResults.push(option)
    }
  }

  return topResults.concat(otherResults)
}

export default filterOptions
